import React, { Component } from 'react';
import { Spin, Table, Tooltip, Button, Icon, Col, Row, Select, DatePicker, Input } from 'antd';
import { sanitizerTexto } from '../../util/utilerias';
import { openNotification } from '../../util/notificaciones';
import CategoriasRequest from '../../services/Categorias';
import CatalogosRequest from '../../services/Catalogos';
import moment from 'moment'
import 'moment/locale/es';
import AsertividadRequest from '../../services/Asertividad';
import * as Excel from "exceljs";
import { saveAs } from "file-saver";
import ResponsiveCard from '../Common/ResponsiveCard';
moment.locale('es')
const { Option } = Select;
const { RangePicker } = DatePicker;
const dateFormat = 'DD/MM/YYYY';

/**
 * Clase para ver el proceso de reporte de asertividad
 */
export default class ReporteAsertividad extends Component {
    state = {
        arrRegiones: [],
        arrSucursales: [],
        arrPlazas: [],
        arrDrives: [],
        regionSelected: null,
        sucursalSelected: null,
        plazaSelected: null,
        drivesSelected: null,
        arrCategorias: [],
        filterText: "",
        cargando: false,
        modo: null,
        tipo_modal: null,
        modalCategorias: false,
        modalCalendario: false,
        disableDeleteFilters: true,
        disableApplyFilters: true,
        arrFuenteDemanda: [],
        arrFuenteDemandaCopy: [],
        categoriaSelected: null,
        variablesModeloPedido: undefined,
        diasFuenteDemanda: [],
        fecha_asertividad: [],
        dateStrings: [],
        arrReporteAsertividad: [],
        arrReporteAsertividadCopy: [],
        dias_range: [],
        scroll: { x: 750 },
        respuesta_asertividad: {},
        columnasAsertividad: [],
        columnasAsertividadOriginal: [
            {
                title: "Código",
                dataIndex: "codigo",
                key: "codigo",
                width: 100
            },
            {
                title: "Descripción",
                dataIndex: "descripcion",
                key: "descripcion",
                width: 300
            },
            {
                title: "UDMP",
                dataIndex: "unidad",
                key: "unidad",
                width: 80
            },
            {
                title: "Categoría",
                dataIndex: "categoria",
                key: "categoria",
                width: 200
            }
        ]
    }

    /**
     * Comportamiento del componente al mostrar el
     * reporte de aseritividad
     */
    componentDidMount = () => {
        let state = { ...this.state }
        CatalogosRequest.ListarRegiones()
            .then(response => {
                state.arrRegiones = response.data
                return CategoriasRequest.ListarCategorias();
            })
            .then(response => {
                state.arrCategorias = response.data;
                state.columnasAsertividad = [...state.columnasAsertividadOriginal]
                this.setState(state)
            })
            .catch(err => {
                openNotification(
                    "Ha ocurrido un error al listar las regiones.",
                    "Error al listar regiones",
                    false
                )
            })
    }

    /**
     * Función que se ejecuta cuando el usuario introduce algo en la barra de búsqueda
     * @param: value. valor de la búsqueda
     * @return: nada. se establece un nuevo valor para la el texto a filtrar.
     */
    filterText = (value) => {
        let state = { ...this.state };
        state.filterText = value;
        let arrReporteAsertividadCopy = state.arrReporteAsertividad
        if (value) {
            arrReporteAsertividadCopy = arrReporteAsertividadCopy.filter(obj => {
                return sanitizerTexto(value, obj.codigo)
                    || sanitizerTexto(value, obj.descripcion)
                    || sanitizerTexto(value, obj.unidad)
            })
        }
        state.arrReporteAsertividadCopy = arrReporteAsertividadCopy
        this.setState(state);
    }

    /**
     * Función que se cambia la región
     * @param: value. valor del id de la región
     * @return: nada.
     */
    handleChangeRegion = (value) => {
        let state = { ...this.state }
        state.sucursalSelected = null;
        state.plazaSelected = null;
        state.drivesSelected = null;
        state.categoriaSelected = null;
        state.arrFuenteDemanda = [];
        state.arrFuenteDemandaCopy = [];
        state.variablesModeloPedido = undefined;
        if (value === undefined) {
            state.regionSelected = null;
            state.disableDeleteFilters = true
        } else {
            state.regionSelected = value
            CatalogosRequest.ListarSucursalesRegion(value).then(response => {
                state.arrSucursales = response.data
                state.disableDeleteFilters = false
                this.setState(state)
            }).catch(err => {
                openNotification(
                    "Ha ocurrido un error al cargar las sucursales de la región.",
                    "Error al cargar sucursales",
                    false
                )
            })
        }

        this.setState(state)
    }

    /**
     * Función que se cambia la sucursal
     * @param: value. valor del id de la sucursal
     * @return: nada.
     */
    handleChangeSucursal = (value) => {
        let state = { ...this.state }
        state.plazaSelected = null;
        state.drivesSelected = null;
        state.categoriaSelected = null;
        state.arrFuenteDemanda = [];
        state.arrFuenteDemandaCopy = [];
        state.variablesModeloPedido = undefined;
        if (value === undefined) {
            state.sucursalSelected = null;
        } else {
            state.sucursalSelected = value
            CatalogosRequest.ListarPlazasSucursal(value).then(response => {
                state.arrPlazas = response.data
                this.setState(state)
            }).catch(err => {
                openNotification(
                    "Ha ocurrido un error al cargar las plazas de la sucursal.",
                    "Error al cargar plazas",
                    false
                )
            })
        }

        this.setState(state)
    }

    /**
     * Función que se cambia la plaza
     * @param: value. valor del id de la plaza
     * @return: nada.
     */
    handleChangePlaza = (value) => {
        let state = { ...this.state }
        state.drivesSelected = null;
        state.categoriaSelected = null;
        state.arrFuenteDemanda = [];
        state.arrFuenteDemandaCopy = [];
        state.variablesModeloPedido = undefined;
        if (value === undefined) {
            state.plazaSelected = null;
        } else {
            state.plazaSelected = value
            CatalogosRequest.ListarSitios(value).then(response => {
                state.arrDrives = response.data
                this.setState(state)
            }).catch(err => {
                openNotification(
                    "Ha ocurrido un error al cargar los drives de la plaza.",
                    "Error al cargar drives",
                    false
                )
            })
        }

        this.setState(state)
    }

    /**
     * Función cuando se cambia el combo de drive
     * @param: value. valor del id del drive
     * @return: nada.
     */
    handleChangeDrive = (value) => {
        let state = { ...this.state }
        state.categoriaSelected = null;
        state.arrFuenteDemanda = [];
        state.arrFuenteDemandaCopy = [];
        state.disableApplyFilters = true
        state.variablesModeloPedido = undefined;
        if (value === undefined) {
            state.drivesSelected = null;
        } else {
            state.drivesSelected = value
        }

        this.setState(state)
    }

    /**
     * Función cuando se cambia el combo de categoría
     * @param: value. valor del id del categoría
     * @return: nada.
     */
    handleChangeCategoria = (value) => {
        let state = { ...this.state }
        state.arrFuenteDemanda = [];
        state.arrFuenteDemandaCopy = [];
        state.variablesModeloPedido = undefined;
        if (value === undefined) {
            state.categoriaSelected = null;
            state.tipo_modelo = null;
        } else {
            state.categoriaSelected = value
            for (let index = 0; index < state.arrCategorias.length; index++) {
                const element = state.arrCategorias[index];
                if (value === element.id) state.tipo_modelo = element.tipo_modelo
            }
        }

        this.setState(state)
    }

    /**
    * Función para limpiar todos los filtros que han
    * sido manipulados por el usuario.
    * @param: nada
    * @return: nada
    */
    cleanFilters = () => {
        let state = { ...this.state }
        state.disableApplyFilters = true;
        state.disableDeleteFilters = true;
        state.regionSelected = null;
        state.sucursalSelected = null;
        state.plazaSelected = null;
        state.drivesSelected = null;
        state.filterText = "";
        state.categoriaSelected = null;
        state.arrFuenteDemanda = [];
        state.arrFuenteDemandaCopy = [];
        state.variablesModeloPedido = undefined;
        state.columnasAsertividad = [...state.columnasAsertividadOriginal]
        state.scroll.x = 750;
        state.dias_range = 0;
        state.fecha_asertividad = [];
        state.dateStrings = [];
        state.arrReporteAsertividad = [];
        state.arrReporteAsertividadCopy = [];
        this.setState(state);
        openNotification("Los filtros se han limpiado correctamente.", "Filtros limpiados correctamente", true);
    }

    /**
    * Función que se ejecuta cuando se cambia el rangepicker
    * @param: dates. valores  del rangepicker
    * @param: dateStrings. valores en formato string de la fecha
    * @return: nada
    */
    onChangeRange = (dates, dateStrings) => {
        let state = { ...this.state };
        let diferencia_dias = moment(dates[1]).diff(moment(dates[0]), 'days');
        let dias_range = [];
        let dia_inicial_string = moment(dateStrings[0], 'DD/MM/YYYY')
        for (let index = 0; index < diferencia_dias + 1; index++) {
            dias_range.push(moment(dia_inicial_string).add(index, 'd').format('DD/MM/YYYY'))
        }
        state.dias_range = dias_range;
        state.fecha_asertividad = dates;
        state.dateStrings = dateStrings;
        state.disableApplyFilters = dates.length ? false : true
        this.setState(state);
    }

    /**
     * Función que se ejecuta para cargar 
     * el reporte de asertividad
     */
    buscarReporteAsertividad = () => {
        let state = { ...this.state }
        let objEnviar = {};
        if (state.dias_range.length > 31) {
            openNotification(
                "Favor de seleccionar un rango de fechas igual o menor a 31 días.",
                "Error en rango de fechas",
                false
            )
            return;
        }
        state.cargando = true;
        state.disableApplyFilters = true;
        state.disableDeleteFilters = true;
        objEnviar.fecha_inicial = state.dateStrings[0];
        objEnviar.fecha_final = state.dateStrings[1];
        objEnviar.drive_id = state.drivesSelected;
        objEnviar.categoria_id = state.categoriaSelected !== null ? state.categoriaSelected : undefined;
        state.columnasAsertividad = [...state.columnasAsertividadOriginal]
        state.scroll.x = 750;

        this.setState(state, () => {
            AsertividadRequest.ReporteAsertividad(objEnviar)
                .then(response => {
                    state.scroll.x = state.scroll.x + (150 * state.dias_range.length)
                    state.respuesta_asertividad = response.data.respuesta;
                    state.dias_range.forEach((dia_range) => {
                        state.columnasAsertividad.push(
                            {
                                title: dia_range,
                                children: [
                                    {
                                        title: 'Sugerido',
                                        key: Math.random(),
                                        width: 100,
                                        render: (element) => {
                                            let llaves = Object.keys(element.fechas);
                                            let valor = 0;
                                            for (let index = 0; index < llaves.length; index++) {
                                                if (dia_range === llaves[index]) {
                                                    valor = element.fechas[llaves[index]].sugerido
                                                }
                                            }
                                            return (<span>{valor}</span>)
                                        }
                                    },
                                    {
                                        title: 'Extra',
                                        key: Math.random(),
                                        width: 100,
                                        render: (element) => {
                                            let llaves = Object.keys(element.fechas);
                                            let valor = 0;
                                            for (let index = 0; index < llaves.length; index++) {
                                                if (dia_range === llaves[index]) {
                                                    valor = element.fechas[llaves[index]].extra
                                                }
                                            }
                                            return (<span>{valor}</span>)
                                        }
                                    },
                                ]
                            }
                        )
                    });
                    state.arrReporteAsertividad = response.data.hasOwnProperty('respuesta') ? response.data.respuesta.articulos : [];
                    state.arrReporteAsertividadCopy = response.data.hasOwnProperty('respuesta') ? response.data.respuesta.articulos : [];
                    state.cargando = false;
                    state.disableApplyFilters = false;
                    state.disableDeleteFilters = false;
                    this.setState(state)
                })
                .catch(err => {
                    this.setState({
                        cargando: false,
                        disableApplyFilters: false,
                        disableDeleteFilters: false,
                    })
                    openNotification(
                        err.response.data.cuerpo,
                        err.response.data.titulo,
                        false
                    )
                })
        })
    }

    /**
     * Función que se ejecuta para descargar 
     * el reporte de asertividad
     */
    descargarReporte = () => {
        let state = { ...this.state }
        let variables = state.respuesta_asertividad;
        let dia_actual = moment(new Date()).format("DD/MM/YYYY")

        let datos_variables = {
            'Sucursal': variables.sucursal,
            'Drive': variables.sitio,
            'Día de reporte': dia_actual,
        }

        var wb = new Excel.Workbook();
        var ws = wb.addWorksheet('Reporte de asertividad');

        const fontStyle = {
            name: 'Arial',
            color: { argb: 'FFFFFFFF' },
            bold: true,
            size: 12
        }
        const alignmentStyle = {
            vertical: 'middle',
            horizontal: 'center'
        }
        const borderStyle = {
            top: { color: { rgb: '110, 105, 105' } },
            left: { color: { rgb: '110, 105, 105' } },
            bottom: { color: { rgb: '110, 105, 105' } },
            right: { color: { rgb: '110, 105, 105' } }
        }
        const fillStyle = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '506e6969' }
        }
        const styleFormat = {
            font: fontStyle,
            alignment: alignmentStyle,
            border: borderStyle,
            fill: fillStyle
        }

        ws.mergeCells('D1', 'D2');
        ws.mergeCells('E1', 'E2');
        ws.mergeCells('F1', 'F2');
        ws.mergeCells('G1', 'G2');
        ws.mergeCells('H1', 'H2');
        ws.mergeCells('I1', 'I2');
        ws.mergeCells('J1', 'J2');
        ws.mergeCells('K1', 'K2');
        ws.columns = [
            { key: 'A', width: 20 },
            { key: 'B', width: 18 },
            { key: 'C', width: 5 },
            { header: 'Fecha', key: 'fecha', width: 15 },
            { header: 'Código', key: 'codigo', width: 15 },
            { header: 'Descripción', key: 'descripcion', width: 50 },
            { header: 'UDMP', key: 'udmp', width: 14 },
            { header: 'Categoría', key: 'categoria', width: 20 },
            { header: 'Sugerido', key: 'sugerido', width: 14 },
            { header: 'Real', key: 'real', width: 10 },
            { header: 'Diferencia', key: 'diferencia', width: 15 }
        ]

        ws.getRow(1).height = 20;
        ws.getCell('D1').style = styleFormat;
        ws.getCell('E1').style = styleFormat;
        ws.getCell('F1').style = styleFormat;
        ws.getCell('G1').style = styleFormat;
        ws.getCell('H1').style = styleFormat;
        ws.getCell('I1').style = styleFormat;
        ws.getCell('J1').style = styleFormat;
        ws.getCell('K1').style = styleFormat;

        state.dias_range.forEach((element) => {
            variables.articulos.forEach((obj) => {
                let fechas_llaves = Object.keys(obj.fechas);
                let valor_find = fechas_llaves.find(fecha_key => fecha_key === element);
                if (valor_find !== undefined) {
                    ws.addRow({
                        fecha: element,
                        codigo: obj.codigo,
                        descripcion: obj.descripcion,
                        udmp: obj.unidad,
                        categoria: obj.categoria,
                        sugerido: obj.fechas[valor_find].sugerido,
                        real: (obj.fechas[valor_find].extra + obj.fechas[valor_find].sugerido),
                        diferencia: obj.fechas[valor_find].extra,
                    })
                } else {
                    ws.addRow({
                        fecha: element,
                        codigo: obj.codigo,
                        descripcion: obj.descripcion,
                        udmp: obj.unidad,
                        categoria: obj.categoria,
                        sugerido: '-',
                        real: '-',
                        diferencia: '-',
                    })
                }
            })
        });

        let indice_row = 1;  // Contador para los renglones del archivo.
        Object.entries(datos_variables).forEach(arr => {
            ws.getRow(indice_row).getCell(1).value = arr[0];
            ws.getCell(`A${indice_row}`).style = styleFormat;
            ws.getRow(indice_row).getCell(2).value = arr[1];
            indice_row += 1;
        })

        wb.creator = 'Pedido Sugerido';
        wb.title = `Archivo para ver el reporte de asertividad`;

        wb.xlsx.writeBuffer()
            .then(buffer => {
                var data = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                saveAs(data, `Reporte de asertividad.xlsx`);
            })
    }

    render() {
        return (
            <ResponsiveCard id="ParentSize"
                title="Módulo asertividad de pedido"
                extra={
                    <div>
                        <Button
                            id="boton-descargar-asertividad-excel"
                            type="primary"
                            style={{ marginRight: 20 }}
                            disabled={this.state.arrReporteAsertividad.length ? false : true}
                            onClick={() => {
                                this.descargarReporte()
                            }}
                        >
                            Descargar reporte
                    </Button>
                    </div>
                }
            >
                <div className="panel-block">
                    <div style={{ marginBottom: "20px" }}>
                        <Row gutter={12}>
                            <Col span={6}>
                                <div className="center">Región:</div>
                                <Tooltip
                                    placement="top"
                                    title="Seleccione una región">
                                    <Select
                                        id="select-region-asertividad-modulo"
                                        showSearch
                                        style={{ width: "100%" }}
                                        defaultActiveFirstOption={false}
                                        notFoundContent='No hay opciones'
                                        placeholder="Seleccionar..."
                                        optionFilterProp="children"
                                        onChange={this.handleChangeRegion}
                                        value={this.state.regionSelected}
                                    >
                                        <Option value={null} disabled={true}>Seleccionar...</Option>
                                        {
                                            this.state.arrRegiones.length > 0 &&
                                            this.state.arrRegiones.map(obj => {
                                                return (
                                                    <Option
                                                        key={obj.id}
                                                        value={obj.id}>
                                                        {obj.nombre_corto}
                                                    </Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </Tooltip>
                            </Col>
                            <Col span={6}>
                                <div className="center">Sucursal:</div>
                                <Tooltip
                                    placement="top"
                                    title="Seleccione una sucursal">
                                    <Select
                                        id="select-sucursal-asertividad-modulo"
                                        showSearch
                                        style={{ width: "100%" }}
                                        defaultActiveFirstOption={false}
                                        notFoundContent='No hay opciones'
                                        placeholder="Seleccionar..."
                                        optionFilterProp="children"
                                        disabled={this.state.regionSelected === null ? true : false}
                                        onChange={this.handleChangeSucursal}
                                        value={this.state.sucursalSelected}
                                    >
                                        <Option value={null} disabled={true}>Seleccionar...</Option>
                                        {
                                            this.state.arrSucursales.length > 0 &&
                                            this.state.arrSucursales.map(obj => {
                                                return (
                                                    <Option
                                                        key={obj.id}
                                                        value={obj.id}>
                                                        {obj.nombre}
                                                    </Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </Tooltip>
                            </Col>
                            <Col span={6}>
                                <div className="center">Plaza:</div>
                                <Tooltip
                                    placement="top"
                                    title="Seleccione una plaza">
                                    <Select
                                        id="select-plaza-asertividad-modulo"
                                        showSearch
                                        style={{ width: "100%" }}
                                        defaultActiveFirstOption={false}
                                        notFoundContent='No hay opciones'
                                        placeholder="Seleccionar..."
                                        optionFilterProp="children"
                                        disabled={this.state.sucursalSelected === null ? true : false}
                                        onChange={this.handleChangePlaza}
                                        value={this.state.plazaSelected}
                                    >
                                        <Option value={null} disabled={true}>Seleccionar...</Option>
                                        {
                                            this.state.arrPlazas.length > 0 &&
                                            this.state.arrPlazas.map(obj => {
                                                return (
                                                    <Option
                                                        key={obj.id}
                                                        value={obj.id}>
                                                        {obj.nombre}
                                                    </Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </Tooltip>
                            </Col>
                            <Col span={6}>
                                <div className="center">Drive:</div>
                                <Tooltip
                                    placement="top"
                                    title="Seleccione drive">
                                    <Select
                                        id="select-drive-asertividad-modulo"
                                        showSearch
                                        style={{ width: "100%" }}
                                        defaultActiveFirstOption={false}
                                        notFoundContent='No hay opciones'
                                        placeholder="Seleccionar..."
                                        optionFilterProp="children"
                                        disabled={this.state.plazaSelected === null ? true : false}
                                        onChange={this.handleChangeDrive}
                                        value={this.state.drivesSelected}
                                    >
                                        <Option value={null} disabled={true}>Seleccionar...</Option>
                                        {
                                            this.state.arrDrives.length > 0 &&
                                            this.state.arrDrives.map(obj => {
                                                return (
                                                    <Option
                                                        key={obj.id}
                                                        value={obj.id}>
                                                        {obj.nombre}
                                                    </Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </Tooltip>
                            </Col>
                        </Row> <br />
                        <Row gutter={12}>
                            <Col span={6}>
                                <Tooltip placement="top" title="Rango de fecha">
                                    <div className="center">Rango de fecha:</div>
                                    <RangePicker
                                        format={dateFormat}
                                        placeholder={["Día inicial", "Día final"]}
                                        value={this.state.fecha_asertividad}
                                        disabled={this.state.drivesSelected !== null ? false : true}
                                        ranges={{
                                            'Hoy': [moment(), moment()],
                                            'Última Semana': [moment().subtract(6, 'days').startOf('day'), moment()],
                                            'Último Mes': [moment().subtract(29, 'days').startOf('day'), moment()]
                                        }}
                                        onChange={(dates, dateStrings) => {
                                            this.onChangeRange(dates, dateStrings);
                                        }}
                                    />
                                </Tooltip>
                            </Col>
                            <Col span={6}>
                                <div className="center">Categoría:</div>
                                <Tooltip
                                    placement="top"
                                    title="Seleccione una categoría">
                                    <Select
                                        id="select-categoria-asertividad-modulo"
                                        showSearch
                                        style={{ width: "100%" }}
                                        defaultActiveFirstOption={false}
                                        notFoundContent='No hay opciones'
                                        placeholder="Seleccionar..."
                                        optionFilterProp="children"
                                        disabled={this.state.drivesSelected === null ? true : false}
                                        onChange={this.handleChangeCategoria}
                                        value={this.state.categoriaSelected}
                                        allowClear
                                    >
                                        <Option value={null} disabled={true}>Seleccionar...</Option>
                                        {
                                            this.state.arrCategorias.length > 0 &&
                                            this.state.arrCategorias.map(obj => {
                                                return (
                                                    <Option
                                                        key={obj.id}
                                                        value={obj.id}>
                                                        {obj.descripcion}
                                                    </Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </Tooltip>
                            </Col>
                            <Col span={2}>
                                <Tooltip placement="top" title={this.state.plazaSelected !== null ? "Realizar búsqueda" : ""}>
                                    <Button
                                        id="boton-filtrar-asertividad-pedido"
                                        className={this.state.disableApplyFilters ? "disableBtn" : ""}
                                        type={this.state.disableApplyFilters ? "default" : "primary"}
                                        icon="search"
                                        style={{ width: '80%', marginLeft: '4.5%', marginBottom: "30px", marginTop: '1.7em' }}
                                        onClick={this.buscarReporteAsertividad}
                                    >
                                    </Button>
                                </Tooltip>
                            </Col>
                            <Col span={2}>
                                <Tooltip placement="top" title="Borrar filtros">
                                    <Button
                                        id="boton-borrar-filtros-asertividad-pedido"
                                        type="default"
                                        icon="delete"
                                        className={this.state.disableDeleteFilters ? 'disableBtn' : ''}
                                        style={{ width: '80%', marginLeft: '2.5%', marginBottom: "30px", marginTop: '1.7em' }}
                                        onClick={this.cleanFilters}
                                    >
                                    </Button>
                                </Tooltip>
                            </Col>
                        </Row>
                        <Row gutter={12}>
                            <Col className={this.state.arrReporteAsertividad.length ? '' : 'display-none'} span={12}>
                                <div className="center">Búsqueda:</div>
                                <Tooltip
                                    placement="top"
                                    title="Buscar por Código / Descripción / UDMP">
                                    <Input
                                        maxLength={50}
                                        id="input-buscar-articulos-generar-pedido"
                                        placeholder="Buscar por Código / Descripción / UDMP"
                                        onChange={(e) => this.filterText(e.currentTarget.value)}
                                        value={this.state.filterText}
                                    />
                                </Tooltip>
                            </Col>
                        </Row>
                    </div>

                    <Spin
                        tip="Cargando..."
                        indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                        spinning={this.state.cargando}
                        style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}>
                        <Table size="small"
                            locale={{ emptyText: 'No se han encontrado resultados' }}
                            rowKey={articulos => articulos.codigo}
                            columns={this.state.columnasAsertividad}
                            dataSource={this.state.arrReporteAsertividadCopy}
                            pagination={{ showTitle: false }}
                            scroll={this.state.scroll}
                        />
                    </Spin>
                </div>
            </ResponsiveCard>
        )
    }
}